const cupra = {
  appConfig: {
    brandName: 'cupra',
    language: 'de-DE',
    isCarTypeSelectionEnabled: true
  }
};

export default cupra;
